module.exports = __webpack_public_path__ + "static/media/sig_styles.0efd33e6.cssm";